

import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, requiredPermissions = [] }) => {
  const { isAuthenticated } = useAuth();
  const permissions = useSelector((state) => state.auth.permissions);

  if (!isAuthenticated) return <Navigate to="/" replace />;

  const hasAccess = requiredPermissions.every((perm) => permissions.includes(perm));
  if (requiredPermissions.length > 0 && !hasAccess) return <Navigate to="/dashboard" replace />;

  return children;
};

export default ProtectedRoute;
